import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BulletSquareIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BulletSquare",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2 5.18h7.53v7.53H2zm0 14.06h7.53v7.53H2zm27.06.06H14.01a.939.939 0 1 0 0 1.88h15.05a.939.939 0 1 0 0-1.88m-7.53 5.65H14a.939.939 0 1 0 0 1.88h7.53a.939.939 0 1 0 0-1.88M14.01 7.06h15.05a.939.939 0 1 0 0-1.88H14.01a.939.939 0 1 0 0 1.88m0 5.65h7.53a.939.939 0 1 0 0-1.88h-7.53a.939.939 0 1 0 0 1.88"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 7.14H14.43a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28M21.29 12.86h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28M28.14 22H14.43a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28M21.29 27.71h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28M3 6h5.71v5.71H3z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.71 12.86H3c-.63 0-1.14-.51-1.14-1.14V6.01c0-.63.51-1.14 1.14-1.14h5.71c.63 0 1.14.51 1.14 1.14v5.71c0 .63-.51 1.14-1.14 1.14m-4.57-2.29h3.43V7.14H4.14zM3 20.86h5.71v5.71H3z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.71 27.71H3c-.63 0-1.14-.51-1.14-1.14v-5.71c0-.63.51-1.14 1.14-1.14h5.71c.63 0 1.14.51 1.14 1.14v5.71c0 .63-.51 1.14-1.14 1.14m-4.57-2.28h3.43V22H4.14z"
      })]
    })
  }));
};
BulletSquareIcon.displayName = 'BulletSquareIcon';